module.exports = __webpack_public_path__ + "static/assets/94156ed51830fb135a86a9bb099be0dc.svg";